import React from "react";
import { useTranslation } from 'react-i18next';
import ExtendedLink from "./ExtendedLink";
import Image from "./Image";

export default function (props) {
    const { user, settings} = props;
    const { t } = useTranslation();
    return (!user || !user.isAuthenticated) ? 
        (
            <button className="account-link">
                <div className="user-ava">
                    <i className="icon-head" />
                </div>
                <div className="user-info">
                    <h6 className="user-name">{t("Guest")} </h6>
                </div>
            </button>
        )
        : (
            <ExtendedLink to={`${settings.baseUrl}account/profile`} className="account-link offcanvas-menu-link">
          
                <div className="user-ava">
                    {user.imageUrl
                        ? <Image src={user.imageUrl ? user.imageUrl : "img/no-image.jpg"}
                            fallbackSrc="img/no-image.jpg" alt={`${user.firstName} ${user.lastName}`} />
                        //<img src={user.imageUrl ? user.imageUrl : "img/no-image.jpg"}
                        //    alt={`${user.firstName} ${user.lastName}`} />
                        : <i className="icon-head" />
                        }
          </div>
          <div className="user-info">
                    <h6 className="user-name">{`${user.firstName} ${user.lastName}`}</h6>
              <span className="text-sm text-white opacity-60">
                        {user.activeTotalPoints} {t("ENJO Points")}
                        </span>
          </div>
            </ExtendedLink>
  );
}

